"use client";

import { useEffect } from "react";
import {
  BIEvents,
  useTimingEvent,
} from "@/_components/lib/mixpanel/mixpanelClient";

export const TrackBlogListingStay = () => {
  const { startTrack, stopTrack } = useTimingEvent(
    BIEvents.BLOG_STAY_ON_LISTING,
    { page: "blog_listing" },
  );

  useEffect(() => {
    startTrack();
    return () => {
      stopTrack();
    };
  }, []);

  return null;
};
